import { useNavigate } from 'react-router-dom';

/**
 * Hook personalizado para manejar navegación relacionada con autenticación
 * Asegura que todas las redirecciones sean a rutas /app/*
 */
export const useAuthNavigation = () => {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate('/app/login', { replace: true });
  };

  const navigateToApp = (path = '/app/dashboard') => {
    // Asegurar que la ruta siempre comience con /app/
    const safePath = path.startsWith('/app/') ? path : '/app/dashboard';
    navigate(safePath, { replace: true });
  };

  const navigateAfterLogin = (from) => {
    const targetPath = from?.pathname || '/app/dashboard';
    const safePath = targetPath.startsWith('/app/') ? targetPath : '/app/dashboard';
    navigate(safePath, { replace: true });
  };

  return {
    navigateToLogin,
    navigateToApp,
    navigateAfterLogin
  };
};

export default useAuthNavigation;